import { makeStyles, Typography, Box } from '@material-ui/core';
import { Page, Content } from '@backstage/core-components';

import oneLoopAiLogo from '../../assets/oneloopai-logo.svg';
import { HeaderSection } from '../ui/HeaderSection';
import { HeroCarousel } from '../ui/HeroCarousel';
import { AcceleratorsSection } from '../ui/AcceleratorsSection';
import { AiSearchBox } from '@internal/plugin-ai-chatbot';

const useStyles = makeStyles(theme => ({
  boxContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '15px',
    borderColor: '#E2E8F0',
    borderWidth: '1px',
    borderStyle: 'solid',
    boxShadow: '0px 3.5px 5.5px 0px rgba(0,0,0,0.02)',
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3),
  },
  boxTitle: {
    color: '#2D3748',
    fontSize: '32px',
    fontWeight: 700,
    textAlign: 'center',
    lineHeight: 1.4,
    marginBottom: theme.spacing(2),
  },
  boxSubtitle: {
    color: '#A0AEC0',
    fontSize: '16px',
    lineHeight: 1.5,
    textAlign: 'center',
    padding: '25px 90px',
  },
}));

const heroSlides = [
  {
    title: 'Accelerate Your Innovation Cycle',
    description:
      "Don't start from scratch. Leverage our library of pre-built, production-ready AI application templates to deploy solutions in record time.",
    buttonText: 'View All Accelerators',
    buttonHref: '/catalog',
    backgroundImage: '/assets/slides/slide_1.png',
  },
  {
    title: "New Here? Let's Build Your First AI Project.",
    description:
      'Guided, step-by-step tutorial designed to get you up to speed. Learn how to select, customize, and deploy an AI accelerator in minutes.',
    buttonText: 'View All Accelerators',
    buttonHref: '/catalog',
    backgroundImage: '/assets/slides/slide_2.png',
  },
  {
    title: 'Beyond Templates: Enterprise-Grade Customization.',
    description:
      'Extend and customize our modules using SDK and Terraform. Integrate deeply with your infrastructure and scale to production-level workloads.',
    buttonText: 'View All Accelerators',
    buttonHref: '/catalog',
    backgroundImage: '/assets/slides/slide_3.png',
  },
];

export const HomePage = () => {
  const classes = useStyles();

  return (
    <Page themeId="home">
      <Content>
        {/* Header Section */}
        <HeaderSection
          logo={oneLoopAiLogo}
          logoAlt="HTEC OneLoopAi Blueprints"
          title="HTEC OneLoopAi Blueprints"
          subtitle="Your gateway to building intelligent applications faster"
        />

        {/* Welcome Section */}
        <Box className={classes.boxContainer}>
          <Typography variant="h3" className={classes.boxTitle}>
            Welcome to Blueprints
          </Typography>
          <Typography variant="body1" className={classes.boxSubtitle}>
            Build production-ready AI applications in days, not months. Discover
            templates, SDK modules, and infrastructure components designed to
            accelerate your AI journey. Whether you're building RAG systems,
            chat agents, or custom AI pipelines, we've got you covered.
          </Typography>

          {/* AI-Powered Search */}
          <AiSearchBox
            placeholder="Ask AI anything about the platform..."
            showSuggestions
          />
        </Box>

        {/* Hero Carousel */}
        <HeroCarousel slides={heroSlides} autoRotateMs={6000} />

        {/* Accelerators — loaded dynamically from Catalog */}
        <Typography
          variant="h5"
          gutterBottom
          style={{ fontWeight: 600, marginBottom: '24px' }}
        >
          Accelerators
        </Typography>
        <AcceleratorsSection maxItems={6} />
      </Content>
    </Page>
  );
};
